import { useState } from "react";
import { Link, NavLink, Outlet } from "react-router-dom";
import { Show, UserButton } from "@clerk/react";
import { Menu, X, ShieldCheck } from "lucide-react";
import { Logo } from "@/components/brand/Logo";
import { useSite } from "@/context/Session";

const NAV = [["/como-funciona", "Como funciona"], ["/servicos", "Serviços"], ["/planos", "Planos e preços"], ["/para-quem", "Para quem é"],
  ["/faq", "Perguntas"], ["/sobre", "Sobre"], ["/contato", "Contato"]];

export default function PublicLayout() {
  const [open, setOpen] = useState(false);
  const site = useSite();
  return (
    <div className="min-h-screen bg-[#F4F6F8]">
      <header className="sticky top-0 z-40 border-b border-[#DFE6E9] bg-white/85 backdrop-blur-xl">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 lg:px-8">
          <Link to="/" data-testid="nav-home"><Logo /></Link>
          <nav className="hidden items-center gap-1 lg:flex">
            {NAV.map(([to, l]) => (
              <NavLink key={to} to={to} data-testid={`nav-${to.slice(1)}`} className={({ isActive }) => `rounded-lg px-3 py-2 text-sm font-medium transition-colors hover:bg-[#E3FAF7] ${isActive ? "text-[#12343B] bg-[#E3FAF7]" : "text-[#587178]"}`}>{l}</NavLink>
            ))}
          </nav>
          <div className="hidden items-center gap-2 lg:flex">
            <Show when="signed-out">
              <Link to="/sign-in" className="btn-ghost" data-testid="nav-login">Entrar</Link>
              <Link to="/sign-up" className="btn-primary" data-testid="nav-signup">Criar conta</Link>
            </Show>
            <Show when="signed-in">
              <Link to="/app" className="btn-primary" data-testid="nav-open-app">Acessar plataforma</Link>
              <UserButton />
            </Show>
          </div>
          <button className="lg:hidden p-2" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">{open ? <X /> : <Menu />}</button>
        </div>
        {open && (
          <div className="border-t border-[#DFE6E9] bg-white px-5 py-4 lg:hidden" onClick={() => setOpen(false)}>
            {NAV.map(([to, l]) => <Link key={to} to={to} className="block rounded-lg px-3 py-3 font-medium text-[#12343B]">{l}</Link>)}
            <div className="mt-3 grid grid-cols-2 gap-2">
              <Link to="/sign-in" className="btn-ghost">Entrar</Link>
              <Link to="/sign-up" className="btn-primary">Criar conta</Link>
            </div>
          </div>
        )}
      </header>
      <Outlet />
      <footer className="bg-[#12343B] text-white/80">
        <div className="mx-auto grid max-w-7xl gap-10 px-5 py-14 md:grid-cols-4 lg:px-8">
          <div className="md:col-span-2">
            <Logo light size="text-3xl" />
            <p className="mt-3 max-w-sm text-sm">{site.slogan || "Sua contabilidade inteligente, simples e humana."}</p>
            <p className="mt-6 flex max-w-md items-start gap-2 text-xs text-white/60"><ShieldCheck className="h-4 w-4 shrink-0 text-[#81D8D0]" />
              A Normah é uma plataforma de tecnologia. Serviços contábeis são prestados por organizações contábeis parceiras registradas, com responsável técnico identificado. Imagens do site são ilustrativas.</p>
          </div>
          <div className="space-y-2 text-sm">
            <p className="font-semibold text-white">Plataforma</p>
            {NAV.slice(0, 4).map(([to, l]) => <Link key={to} to={to} className="block hover:text-[#81D8D0]">{l}</Link>)}
          </div>
          <div className="space-y-2 text-sm">
            <p className="font-semibold text-white">Institucional</p>
            <Link to="/sobre" className="block hover:text-[#81D8D0]">Sobre a empresa</Link>
            <Link to="/contato" className="block hover:text-[#81D8D0]">Contato</Link>
            <Link to="/termos" className="block hover:text-[#81D8D0]" data-testid="footer-terms">Termos e privacidade</Link>
          </div>
        </div>
        <div className="border-t border-white/10 px-5 py-5 text-center text-xs text-white/50" data-testid="footer-legal">
          © {new Date().getFullYear()} {site.brand_name || "Normah Contabilidade Digital"}
          {site.company_cnpj && <> · <span className="whitespace-nowrap">CNPJ {site.company_cnpj}</span></>}
          {site.contact_email && <> · <a href={`mailto:${site.contact_email}`} className="hover:text-[#81D8D0]">{site.contact_email}</a></>}
        </div>
      </footer>
    </div>
  );
}
